var _rect, _rect2, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBadFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 30,
    height: 30,
    rx: 15,
    fill: "url(#paint0_radial_7983_3214)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#C28000",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4834 28.5833C12.8167 25.1833 16.1167 22.75 20.0001 22.75C23.8834 22.75 27.1834 25.1833 28.5167 28.5833H11.4834Z",
    fill: "#C28000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.084 18.082C15.4173 18.082 16.584 16.9154 16.584 15.582V13.082L11.584 15.582C11.584 16.9154 12.7507 18.082 14.084 18.082Z",
    fill: "#C28000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.209 18.082C23.8757 18.082 22.709 16.9154 22.709 15.582V13.082L27.709 15.582C27.709 16.9154 26.5423 18.082 25.209 18.082Z",
    fill: "#C28000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7983_3214",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.5 10) rotate(82.3332) scale(26.2345)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFFC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.579521,
    stopColor: "#FFE83B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE83B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBadFill);
export default __webpack_public_path__ + "static/media/IconBadFill.cb03e1060c9c32cbeeebe916dd5e7045.svg";
export { ForwardRef as ReactComponent };